import PageLayout from '@/components/feature/PageLayout';
import Guarantees from '@/pages/home/components/Guarantees';
import WhyWeGuarantee from '@/pages/guarantees/components/WhyWeGuarantee';
import GuaranteesFaq from '@/pages/guarantees/components/GuaranteesFaq';

export default function GuaranteesPage() {
  return (
    <PageLayout>
      <WhyWeGuarantee />
      <Guarantees />
      <GuaranteesFaq />
    </PageLayout>
  );
}